import { combineReducers } from "redux";
import user from "../features/admin/role_permmission/users/Slice";
import roles from "../features/admin/role_permmission/role/Slice";
import builder from "../features/admin/role_permmission/builder/Slice";
import sales from "../features/admin/role_permmission/sales/Slice";

const customers = combineReducers({
    roles: roles,
    builder: builder,
    user: user,
    sales: sales,
  
  });
  
  export default customers;